const defaultStatus = { label: 'No', className: 'badge-danger' };
const DematStatus = ({ dematStatus }) => {
  const statusMap = {
    approved: { label: 'Yes', className: 'badge-success' },
    pending: { label: 'Requested', className: 'badge-warning' },
    rejected: { label: 'Rejected', className: 'badge-danger' },
  };

  const { label, className } = statusMap[dematStatus] || defaultStatus;

  return (
    <span className={`badge ${className}`}>
      {label}
    </span>
  );
};

export default DematStatus;
